export const MAX_SELECTED_COUNT = 20; //you can selected at most MAX_SELECTED_COUNT manufacturers to send your project/request
